import React from "react";
import { Button } from "react-bootstrap";

export default function ChooseAccount({ currencies, onClick }) {

  return (
    <div className="choose-curency">
      {currencies.map((currency, index) => {
         return (
           <Button variant="dark" size="lg" block key={index} onClick={() => onClick(currency)}>
             {currency.isCard ? currency.name + " CARD" : currency.name}
           </Button>
         );
      })}
    </div>
  );
}
